import { render, staticRenderFns } from "./PaceMakerImpiantoView.vue?vue&type=template&id=40751946"
import script from "./PaceMakerImpiantoView.vue?vue&type=script&lang=js"
export * from "./PaceMakerImpiantoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports